module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isPending) ? _c('div', {
    staticClass: "alert alert-success alert-with-icon text-center"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "alert alert-warning alert-with-icon text-center"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_name')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("1/5")])]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "family_name",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_name'),
      "cplaceholder": "(пример: Иван и Мария Иванови)"
    },
    model: {
      value: (_vm.family.name),
      callback: function($$v) {
        _vm.$set(_vm.family, "name", $$v)
      },
      expression: "family.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_people')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("2/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_parents')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', _vm._l((_vm.$config.lists.familyRoles), function(roleDescription, role) {
    return _c('tr', [_vm._l((_vm.usersByRole[role]), function(user) {
      return [_c('td', {
        staticClass: "vertical-middle"
      }, [_c('label', {
        staticClass: "custom-control custom-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.family.role),
          expression: "family.role"
        }],
        staticClass: "custom-control-input",
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": role,
          "checked": _vm._q(_vm.family.role, role)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.family, "role", role)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-control-indicator",
        class: {
          'bg-success': _vm.family.role === role
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-control-description"
      }, [_vm._v(_vm._s(roleDescription.text))])])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle",
        staticStyle: {
          "width": "1px",
          "padding-right": ".4rem !important"
        }
      }, [_c('label', {
        staticClass: "control-label"
      }, [_vm._v(_vm._s(_vm.$t('label.person_name')) + ":")])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": "person_name",
          "hide-name": "",
          "errors": _vm.errorBag.collect('person_name', 'user.' + user.id),
          "cplaceholder": '(пример: ' + roleDescription.placeholder + ')',
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.name),
          callback: function($$v) {
            _vm.$set(user, "name", $$v)
          },
          expression: "user.name"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle",
        staticStyle: {
          "width": "1px",
          "padding-right": ".4rem !important"
        }
      }, [_c('label', {
        staticClass: "control-label"
      }, [_vm._v(_vm._s(_vm.$t('label.person_interests')) + ":")])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        attrs: {
          "name": "person_interests",
          "hide-name": "",
          "cplaceholder": "(разделени със запетая)",
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.interests),
          callback: function($$v) {
            _vm.$set(user, "interests", $$v)
          },
          expression: "user.interests"
        }
      })], 1)]
    }), _vm._v(" "), (_vm.usersByRole[role].length === 0) ? [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "5"
      }
    }, [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.addParent(role)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(roleDescription.text))])])] : _vm._e()], 2)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_children')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_sex')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_birth_year')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.usersByRole.child), function(child, key) {
    return _c('tr', [_c('td', {
      staticClass: "text-center vertical-middle"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_name",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_name', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id,
        "cplaceholder": "Име"
      },
      model: {
        value: (child.name),
        callback: function($$v) {
          _vm.$set(child, "name", $$v)
        },
        expression: "child.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_sex",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_sex', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id,
        "values": _vm.$config.lists.childRoles
      },
      model: {
        value: (child.role),
        callback: function($$v) {
          _vm.$set(child, "role", $$v)
        },
        expression: "child.role"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_birth_year",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_birth_year', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.birthYear),
        callback: function($$v) {
          _vm.$set(child, "birthYear", $$v)
        },
        expression: "child.birthYear"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeChild(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_location')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("3/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.countries,
      "name": "family_country",
      "errors": _vm.errorBag.collect('family_country')
    },
    model: {
      value: (_vm.family.country),
      callback: function($$v) {
        _vm.$set(_vm.family, "country", $$v)
      },
      expression: "family.country"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.states,
      "name": "family_state",
      "errors": _vm.errorBag.collect('family_state')
    },
    model: {
      value: (_vm.family.state),
      callback: function($$v) {
        _vm.$set(_vm.family, "state", $$v)
      },
      expression: "family.state"
    }
  }), _vm._v(" "), _c('f-input', {
    attrs: {
      "name": "family_city",
      "cplaceholder": "(не е задължително)"
    },
    model: {
      value: (_vm.family.city),
      callback: function($$v) {
        _vm.$set(_vm.family, "city", $$v)
      },
      expression: "family.city"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header card-header-text"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_about_us')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("4/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_experience')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "name": "family_experience",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_experience'),
      "cplaceholder": "(пример: 1)"
    },
    model: {
      value: (_vm.family.info.hsExperience),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "hsExperience", $$v)
      },
      expression: "family.info.hsExperience"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_methods')))]), _vm._v(" "), _c('p', [_vm._v("Моля, изберете методите за домашно образование, които използвате във вашето семейство.")]), _vm._v(" "), _vm._l((_vm.$config.lists.hsmethods), function(method, key) {
    return _c('div', {
      staticClass: "row hs_method"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.family.info.hsMethods),
        expression: "family.info.hsMethods"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.family.info.hsMethods) ? _vm._i(_vm.family.info.hsMethods, key) > -1 : (_vm.family.info.hsMethods)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.family.info.hsMethods,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.family.info.hsMethods = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.family.info.hsMethods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.family.info, "hsMethods", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator",
      class: {
        'bg-success': _vm.family.info.hsMethods.indexOf(key) !== -1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_c('strong', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(method.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(method.desc) + "\n\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header card-header-text"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_admin_note')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("5/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('p', [_vm._v("\n\t\t\t\t\tМоля, пишете ни от коя среща за домашно образование се познаваме, за да можем да одобрим достъпа ви до мрежата.\n\t\t\t\t")]), _vm._v(" "), _c('f-textarea', {
    attrs: {
      "name": "family_admin_note",
      "hide-name": "",
      "cplaceholder": "",
      "crows": 15
    },
    model: {
      value: (_vm.family.note),
      callback: function($$v) {
        _vm.$set(_vm.family, "note", $$v)
      },
      expression: "family.note"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_vm._v("Запис")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tРегистрацията Ви изчаква одобрение от АДО!"), _c('br'), _vm._v("\n\t\t\t\tАко искате може да редактирате детайлите на вашата регистрация.\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tТъй като влизате за първи път в "), _c('strong', [_vm._v("\"Семейна образователна мрежа\"")]), _vm._v(", ще трябва да регистрирате своя семеен профил."), _c('br'), _vm._v("\n\t\t\t\tРегистрацията Ви трябва да бъде одобрена от АДО, за да получите достъп до мрежата.\n\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61c4283a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/dashboard/Registration.vue
// module id = 658
// module chunks = 1